import { Globe, Clock, MapPin, Monitor, Users } from "lucide-react";
import { useTranslation } from "react-i18next";

interface AnalyticsStatsProps {
  totalRecords: number;
  allRecords: any[];
  formatDuration: (seconds: number) => string;
}

export const AnalyticsStats = ({
  totalRecords,
  allRecords,
  formatDuration,
}: AnalyticsStatsProps) => {
  const { t } = useTranslation("analytics");
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
      <div className="bg-muted/50 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-1">
          <Globe className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm font-medium">
            {t("analytics:analyticsTable.totalSessions")}
          </span>
        </div>
        <p className="text-2xl font-bold">{totalRecords.toLocaleString()}</p>
      </div>
      <div className="bg-muted/50 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-1">
          <Users className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm font-medium">
            {t("analytics:analyticsTable.uniqueVisitors")}
          </span>
        </div>
        <p className="text-2xl font-bold">
          {new Set(allRecords.map((r) => r.ip_address).filter(Boolean)).size}
        </p>
      </div>
      <div className="bg-muted/50 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-1">
          <Clock className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm font-medium">
            {t("analytics:analyticsTable.avgDuration")}
          </span>
        </div>
        <p className="text-2xl font-bold">
          {allRecords.length > 0
            ? formatDuration(
                Math.round(
                  allRecords.reduce(
                    (sum, record) => sum + record.total_duration_seconds,
                    0
                  ) / allRecords.length
                )
              )
            : "0s"}
        </p>
      </div>
      <div className="bg-muted/50 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-1">
          <MapPin className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm font-medium">
            {t("analytics:analyticsTable.countries")}
          </span>
        </div>
        <p className="text-2xl font-bold">
          {new Set(allRecords.map((r) => r.country_code).filter(Boolean)).size}
        </p>
      </div>
      <div className="bg-muted/50 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-1">
          <Monitor className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm font-medium">Devices</span>
        </div>
        <p className="text-2xl font-bold">
          {new Set(allRecords.map((r) => r.device_type).filter(Boolean)).size}
        </p>
      </div>
    </div>
  );
};
